import React from "react";
import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import { Select } from "components";
import { AutoCompleteInstance } from "duck";
import { Fragments } from "requests";
import * as duck from "./duck";

interface CreateProps {
  exclude: Fragments.StoredDiagnosticTesting["additionalTests"];
}

const Create: React.FC<CreateProps> = ({ exclude }) => {
  const ref = React.useRef<AutoCompleteInstance>(null);
  const { value, onSave, onChange } = duck.useAdditionalTests();

  return (
    <Box my={6}>
      <HStack mt={6} mb={4} justify="space-between">
        <Text color="black">Other</Text>
        <Button
          leftIcon={<IoAdd />}
          onClick={() => {
            onChange([]);
            ref.current?.resetCreatedOptions();
            onSave();
          }}
          disabled={!value.length}
        >
          Add
        </Button>
      </HStack>
      <Select
        creatable
        label="Other"
        labelHidden
        placeholder="Select Other"
        isMulti
        value={value}
        onChange={onChange}
        innerRef={ref}
        options={duck.DEFAULT_ADDITIONAL_OPTIONS.filter(opt => {
          const alreadyExists = exclude.find(
            excOpt => excOpt.test === opt.value
          );
          return !alreadyExists;
        })}
      />
    </Box>
  );
};

export default Create;
